import React from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';

const ErrorMsg = (props) => {
  return (
    <div className='cg-error-msg'>
      <p>
        <span className='bold'>הודעת שגיאה לגבי הכרטיס</span>
        <br />
        נסה אולי כרטיס אחר
      </p>
      <BtnSubmit isBusiness={false} text={'נסה שנית'} onclick={props.onclickTryAgainBtn} formid={'cg-error-msg'} isDisplayArrows={false} />
    </div>
  );
};

export default ErrorMsg;
